import React, {memo} from "react";
import PropTypes from "prop-types";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {FaTimes} from "react-icons/fa";
import {useDispatch} from "react-redux";
import Loader from "../Loader";
import InventoryForm from "../Forms/InventoryForm";
import {addInventory} from "../../redux/Actions/inventory.actions";
import {useFetchInventories} from "../../views/Inventory/inventoryTable/useInventoryTableData";

const AddInventory = (props) => {
  const dispatch = useDispatch();
  const {refetch} = useFetchInventories();
  const {open, onClose, onEdit = false} = props;

  const onSubmit = (formDetails) => {
    let payload = {};
    Object.values(formDetails).map((each) => {
      payload = {
        ...payload,
        ...each,
      };
    });
    const sendingObj = {edit: onEdit, payload};
    const callback = () => {
      onClose();
      refetch();
    };
    dispatch(addInventory(sendingObj, callback));
  };

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
      <Loader />
      <div style={{float: "right"}}>
        <ModalHeader>
          <FaTimes style={{cursor: "pointer"}} onClick={() => onClose()} size={32} />
        </ModalHeader>
      </div>
      <ModalBody>
        {/*<div className="pl-lg-4">*/}
        <InventoryForm onFormSubmit={onSubmit} isEdit={onEdit} />
        {/*</div>*/}
      </ModalBody>
    </Modal>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

AddInventory.propTypes = {
  open: PropTypes.bool,
};
export default memo(AddInventory, areEqual);
